import { ReactNode, useState } from "react";
import { ShowMoreProps } from "react-big-calendar";

import AppButton from "../../Button/AppButton";
import { GenericCalendarEntry, rbcMessages } from "../Calendar";
import { CalendarMonthDayEntriesDetailsPopover } from "../CalendarMonthDayEntriesDetailsPopover";

interface Props<TEntry extends GenericCalendarEntry> extends ShowMoreProps<TEntry> {
  children?: ReactNode;
}

/** Show more button in: month view -> day cell -> show more button. */
export function RBCShowMoreButtonCustom<TEntry extends GenericCalendarEntry>(props: Props<TEntry>) {
  // console.log("RBCMonthDayShowMoreButton", props);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <AppButton
        className='show-more-button-custom'
        variant='text'
        color='text'
        size='extraSmall'
        onMouseDown={(e) => {
          // prevent date cell click
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={(e) => {
          console.log("Calendar.showMoreButton.onClick", e);
          // prevent date cell click
          e.preventDefault();
          e.stopPropagation();
          setPopoverAnchorEl(e.target as HTMLButtonElement);
        }}
      >
        {rbcMessages.showMore(props.count, props.remainingEvents, props.events)}
      </AppButton>

      <CalendarMonthDayEntriesDetailsPopover
        anchorEl={popoverAnchorEl}
        open={!!popoverAnchorEl}
        onClose={() => setPopoverAnchorEl(null)}
        subProps={{
          slotDate: props.slotDate,
          entries: props.events,
          remainingEntries: props.remainingEvents,
          localizer: props.localizer,
        }}
      />
    </>
  );
}
